// Types
import { distributorListSchema, interestFormSchema } from 'modules/interestform/models'

// Types
import { APIAction } from 'types'

export const actions = {
  submitInterest: (data: Record<string, unknown>): APIAction => ({
    CALL_API: {
      type: 'POST_SURVEY_DATA',
      method: 'POST',
      endpoint: '/api/survey/result/',
      schema: interestFormSchema,
      data,
    },
  }),
  fetchDistributors: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_DISTRIBUTORS',
      method: 'GET',
      endpoint: '/api/survey/distributors/',
      schema: distributorListSchema,
    },
  }),
}
